import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import Text from "ab-text";
import Link from "ab-link";
import { useInViewport } from "react-in-viewport";

import "./ab-history.scss";

const HistoryCard = ({
  navlink,
  title,
  imagen,
  animated,
  i18n,
  contenido,
  brief,
  rtl,
  classname,
}) => {
  const [full, setFull] = useState(false);
  const myRef = useRef();
  const { t } = useTranslation("common", { i18n });

  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef,
    { threshold: 0.5 },
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: false }
  );
  const handleScroll = () => {
    const element = document.getElementById(`menu-#${navlink}`);
    const menu = document.getElementById("history-menu");

    if (element) {
      if (inViewport) {
        if (!element?.classList?.contains("selected")) {
          const children = menu?.querySelectorAll("li");
          children.forEach(function (e) {
            if (e.id !== element.id) {
              e?.classList.remove("selected");
              e?.classList.add("not-selected");
            }
          });
          element?.classList.add("selected");
          element?.classList.remove("not-selected");
          menu.scrollLeft = element?.offsetLeft - 10;
        }
      } else {
        if (!element?.classList?.contains("not-selected")) {
          element?.classList.remove("selected");
          element?.classList.add("not-selected");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inViewport]);

  const text = full ? contenido : brief;
  // console.log('Historia ', text);
  return (
    <>
      <a className="reference" id={navlink} />
      <div className={`ab-history-card ${classname}`} ref={myRef}>
        <div className={rtl ? "rtl" : undefined}>
          <img src={imagen?.mediaItemUrl} alt={title} />

          <div className="text-column">
            <Text element="h2" animated={animated}>
              {title}
            </Text>

            <Text element="div" className={"texto"}>
              {text}
            </Text>

            {
              contenido ? (
                <Link
                  prefetch={false}
                  text={full ? t("cerrar") : t("leer-mas")}
                  onClick={() => {
                    setFull(!full);
                  }}
                ></Link>
              ) : null
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryCard;
